import Collection from '../../utils/Collection';

import {
  FETCH_LESSON_ISSUE_SENT,
  FETCH_LESSON_ISSUE_SUCCEEDED,
  FETCH_LESSON_ISSUE_FAILED,
  UPDATE_SELECTED_LESSON_ISSUE_ACTION,
  UPDATE_SELECTED_LESSON_ISSUE_REASON,
  UPDATE_LESSON_ISSUE_COMMENT,
} from '../../actions/lessonIssue';

const initialState = {
  issues: [],
  loading: false,
  selectedIssueType: null,
  selectedAction: null,
  selectedReason: null,
  comment: '',
};

export default function lessonIssueReducer(state = initialState, action) {
  const { payload, type } = action;
  switch (type) {
    case UPDATE_SELECTED_LESSON_ISSUE_ACTION:
      return {
        ...state,
        selectedAction: payload.value,
      };
    case UPDATE_SELECTED_LESSON_ISSUE_REASON:
      return {
        ...state,
        selectedReason: payload.value,
      };
    case UPDATE_LESSON_ISSUE_COMMENT:
      return {
        ...state,
        comment: payload.value,
      };
    case FETCH_LESSON_ISSUE_SENT:
      return {
        ...state,
        loading: true,
      };
    case FETCH_LESSON_ISSUE_FAILED:
      return {
        ...state,
        loading: false,
      };
    case FETCH_LESSON_ISSUE_SUCCEEDED:
      return {
        ...state,
        issues: Collection.add(state.issues, payload.issue),
        loading: false,
      };
    default:
      return state;
  }
}
